export default {
  // 创建项目
  createProject: {
    url: '/medusaApi/createProject',
    method: 'POST'
  },
  // 获取项目列表
  getProjects: {
    url: '/medusaApi/getProjects',
    method: 'POST'
  },
}